/**
 * @desc 根据ID查询相关库容信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.MaterialStorageDTO>> {
  return defHttp.get({
    url: '/web/materialManage/queryById',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.MaterialStorageDTO>> {
  return defHttp.get({
    url: '/mock/web/materialManage/queryById',

    params,
  });
}
